//pages faq
document.addEventListener('DOMContentLoaded', function() {
            const accordions = document.querySelectorAll('.lg_pages_bk button.accordion');
            
            accordions.forEach(function(accordion) {
                accordion.addEventListener('click', function() {
                    const oPanel = this?.nextElementSibling;
                    if (oPanel && typeof oPanel.classList !== 'undefined') {
                        oPanel.classList.toggle('active');
                        this.classList.toggle('active');
                    }
                });
            });
});
//pages faq 结束
